import { Accordion, Box,  Flex,  ScrollArea, Stack, Text } from '@mantine/core'
import  {  useEffect, useMemo, useState } from 'react'
import CardInfo from './CardInfo'
import UpperScroller from './UpperScroller'
import { useElementSize } from '@mantine/hooks'
import CardInfoTextItem from './CardInfoTextItem'
import { useGroupedAggregations } from '../../../../hooks/ideaPage/useIdeaQueries'
import { useEvidenceData } from '../../../../hooks/useEvidenceData'

const CardScroller = ({
  chosenEvidence, 
  ideaPage,
  componentId,
  setComponentId,
  validation,
  isCustomerPage,
  idea: propIdea,
  loadEvidence: propLoadEvidence,
  isIdeaAi = false,
  isLoadingMl = false,
}: 
  {
    chosenEvidence: any,
    ideaPage: boolean,
    componentId: string,
    setComponentId: React.Dispatch<React.SetStateAction<any>>,
    validation?: boolean;
    isCustomerPage: boolean;
    idea?: any;
    loadEvidence?: () => void;
    isIdeaAi: boolean;
    isLoadingMl?: boolean;
  }
) => {

  const { ref , height } = useElementSize();
  const [value, setValue] = useState<string | null>(null)
  const [detailsOpened, setDetailsOpened] = useState(false)
  const [activeTab, setActiveTab] = useState<string | null>("details");

  const isGapMatch: boolean = chosenEvidence?.type === 'gap' && chosenEvidence?.mlComponent
    
  const evidenceIds = chosenEvidence?.isContainer && chosenEvidence?.hasChildren ? [...(chosenEvidence?.childEvidences?.map((child: any) => String(child._id)) ?? [])] : [String(chosenEvidence?._id)];
  const aggregationsQuery = useGroupedAggregations(evidenceIds);

  useEffect(() => {
    if (aggregationsQuery && aggregationsQuery?.data?.aggregations ) {
      chosenEvidence.aggregations = aggregationsQuery?.data?.aggregations[0] || null ;      }
  }, [aggregationsQuery?.data?.aggregations, evidenceIds]);

  // /ideas/:id/requests|matches|requestsMatches (which populate chosenEvidence) don't
  // reliably populate owner/componentObj; /evidences/evidenceDetails/:id does, so overlay
  // just those two fields once the fuller record loads.
  const { evidence: evidenceDetails } = useEvidenceData(chosenEvidence?._id, { initialEvidence: chosenEvidence, refetchDespiteInitial: true });
  const cardInfoItem = useMemo(() => (
    chosenEvidence
      ? {
        ...chosenEvidence,
        componentObj: (evidenceDetails as any)?.componentObj ?? chosenEvidence?.componentObj,
        owner: (evidenceDetails as any)?.owner ?? chosenEvidence?.owner,
        aggregations: aggregationsQuery?.data?.aggregations?.[0] ?? chosenEvidence?.aggregations ?? null,
      }
      : chosenEvidence
  ), [chosenEvidence, evidenceDetails, aggregationsQuery?.data?.aggregations]);

  useEffect(() => {
    setDetailsOpened(false); 
  }, [chosenEvidence]);

  return (
    <Stack justify='space-between'   h={isIdeaAi ? "calc(100vh - 377px)": validation ? "445px" : isCustomerPage ? "calc(100vh - 396px)" : "calc(100vh - 310px)"}  /* h='100%' */>
      <ScrollArea h={validation ? "450px" : isCustomerPage ? "calc(100vh - 476px)" : "calc(100vh - 330px)"} mah={validation ? "450px" : isCustomerPage ? "calc(100vh - 476px)" : "calc(100vh - 330px)"}> 
        <Box ref={ref}>
          <UpperScroller chosenEvidence={chosenEvidence} loadEvidence={propLoadEvidence} isLoadingMl={isLoadingMl}/>
        </Box>
      </ScrollArea>
      {!validation && 
      (
        <Box sx={{ borderTop: "1px solid #D8D8DB" }}>
          <Flex sx={{ borderBottom: "1px solid #D8D8DB" }}>
            <Accordion value={value} onChange={setValue} chevronPosition='left' p={0} m={0}>
              <Accordion.Item value="1"  onClick={()=> setDetailsOpened(!detailsOpened)}>
                <Accordion.Control pl='32px' py="10px"> 
                </Accordion.Control>
              </Accordion.Item>
            </Accordion> 
            
                
            <CardInfo
              item={cardInfoItem}
              ideaPage={ideaPage} 
              isInAccordian={true} 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
              setDetailsOpened={setDetailsOpened}
              componentId={componentId}
              setComponentId={setComponentId}
              isCustomerPage={isCustomerPage}
              idea={propIdea}
              loadEvidence={propLoadEvidence}
            />{/* } */}
          </Flex>
          
          {detailsOpened && <Box px="35px" sx={{ overflowY: "auto", maxHeight: "180px", borderBottom: "1px solid #D8D8DB", minHeight: 350 }} >
            
            <CardInfo
              item={cardInfoItem}
              ideaPage={ideaPage} 
              isInAccordian={false} 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
              setDetailsOpened={setDetailsOpened}
              componentId={componentId}
              setComponentId={setComponentId}
              isCustomerPage={isCustomerPage}
              idea={propIdea}
              loadEvidence={propLoadEvidence}
            />
          </Box>}
        </Box>
      )
      }
      
    </Stack> 
  )
}
export default CardScroller